import { ofetch } from 'ofetch';
import { joinURL } from 'ufo';

import {
  readAccessToken,
  readRefreshExpires,
  readRefreshToken,
  writeAccessToken,
  writeRefreshExpires,
  writeRefreshToken,
} from './helpers';

import type { FetchOptions } from 'ofetch';

let promise: Promise<any> | null = null;

const API_URL = import.meta.env.VITE_APP_API_URL;

export async function onCheckRefresh({ options }: { options?: FetchOptions }) {
  const accessToken = readAccessToken();
  const refreshToken = readRefreshToken();
  const refreshExpired = readRefreshExpires();

  if (accessToken && refreshToken && !refreshExpired && promise == null) {
    promise = ofetch(joinURL(API_URL, 'common', '/refresh-sso-token'), {
      method: 'POST',
      body: {
        code: refreshToken,
      },
      baseURL: 'common',
      headers: accessToken
        ? {
            Authorization: `Bearer ${accessToken}`,
          }
        : undefined,
    }).then(data => {
      const values = data.data;
      promise = null;
      writeRefreshToken(values.refreshToken);
      writeAccessToken(values.accessToken);
      writeRefreshExpires(values.expAt);
      if (options) {
        (
          options.headers as Record<string, string>
        ).Authorization = `Bearer ${readAccessToken()}`;
      }
    });
  }

  if (promise) await promise;
}
